export default __webpack_public_path__ + "static/media/lem_media.b62f24aa.png";